import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Grid, Table, Icon, Header, Button, Tab } from 'semantic-ui-react'
import UserActions from '../../reducers/userReducer'
import RestaurantActions from '../../reducers/restaurantReducer'

import utils from '../../utils'

import Loading from '../../components/common/loading'

import FormModal from './form'
import UserRow from './row'

class UsersManagementContainer extends Component {
  state = {
    modalFormVisible: false,
    isOperatorTab: false,
    isMerchantAdminTab: false,
    selectedUserKey: null,
  }

  componentDidMount() {
    const { loaded, getAllUsers, restaurantLoaded, getRestaurants } = this.props
    if (!loaded) getAllUsers()
    if (!restaurantLoaded) getRestaurants()
  }

  componentWillUnmount() {
    const { removeUsersListener } = this.props

    removeUsersListener()
  }

  renderNoDataRow = () => (
    <Table.Row>
      <Table.Cell textAlign="center" colSpan={6}>
        No Results
      </Table.Cell>
    </Table.Row>
  )

  renderUserRows = (tab, users) => {
    if (_.size(users) > 0) {
      let n = 0
      return _.map(users, (user, userKey) => {
        n += 1
        return (
          <UserRow
            key={userKey}
            data={user}
            userKey={userKey}
            noIndex={n}
            onEdit={() =>
              this.setState({
                selectedUserKey: userKey,
                modalFormVisible: true,
                isOperatorTab: tab === 'operators',
                isMerchantAdminTab: tab === 'merchant_admins',
              })
            }
          />
        )
      })
    }

    return this.renderNoDataRow()
  }

  renderUsers = tab => {
    const { loading, users, restaurants } = this.props
    const currentTabUsers = _.pickBy(users, user => {
      return (
        (tab === 'users' && !['operator@role', 'merchant_admin@role'].includes(user.role)) ||
        (tab === 'operators' && user.role === 'operator@role') ||
        (tab === 'merchant_admins' &&
          user.role === 'merchant_admin@role' &&
          _.some(user.manageMerchantIds, merchantId => restaurants[merchantId]))
      )
    })

    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)', overflowY: 'auto' }}>
        <Loading active={loading} />
        <div
          style={{
            marginBottom: 14,
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>
            <Header size="large" style={{ display: 'inline-block' }}>
              {`List ${_.startCase(tab)} `}
              <strong>({_.size(currentTabUsers)})</strong>
            </Header>
          </div>
          <div>
            <Button
              icon
              color="black"
              onClick={() =>
                this.setState({
                  modalFormVisible: true,
                  isOperatorTab: tab === 'operators',
                  isMerchantAdminTab: tab === 'merchant_admins',
                })
              }
            >
              <Icon name="add" />
            </Button>
          </div>
        </div>
        <Table basic="very">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>#</Table.HeaderCell>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Email</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Region</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                {tab === 'operators' ? 'Status' : 'Role'}
              </Table.HeaderCell>
              {tab === 'merchant_admins' && <Table.HeaderCell textAlign="center">Merchants</Table.HeaderCell>}
              <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.renderUserRows(tab, currentTabUsers)}</Table.Body>
        </Table>
      </Tab.Pane>
    )
  }

  onTabChange = index => {
    const { history } = this.props
    const tabs = Object.keys(this.tabPanes())
    const queryString = tabs[index] ? `?tab=${tabs[index]}` : ''

    history.push(`/users${queryString}`)
  }

  tabPanes = () => ({
    'users': {
      menuItem: 'Users',
      render: () => this.renderUsers('users')
    },
    'operators': {
      menuItem: 'Operators',
      render: () => this.renderUsers('operators')
    },
    'merchant-admins': {
      menuItem: 'Merchant Admins',
      render: () => this.renderUsers('merchant_admins')
    },
  })

  render() {
    const { users } = this.props
    const { modalFormVisible, selectedUserKey, isOperatorTab, isMerchantAdminTab } = this.state
    const selectedUser = users ? users[selectedUserKey] : {}
    const params = utils.helpers.urlParams()
    const tab = params.tab || 'users'
    const tabIndex = Object.keys(this.tabPanes()).indexOf(tab)

    return (
      <div>
        <Grid>
          <Grid.Column width="16">
            <Tab
              activeIndex={tabIndex}
              menu={{ pointing: true }}
              panes={Object.values(this.tabPanes())}
              onTabChange={(e, { activeIndex }) => this.onTabChange(activeIndex)}
              />
            {modalFormVisible && (
              <FormModal
                user={selectedUser}
                uid={selectedUserKey}
                visible={modalFormVisible}
                isOperator={isOperatorTab}
                isMerchantAdmin={isMerchantAdminTab}
                onClose={() => this.setState({ selectedUserKey: null, modalFormVisible: false })}
              />
            )}
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapState = ({ users, restaurants }) => ({
  users: users.data,
  loading: users.loading,
  loaded: users.loaded,
  restaurants: restaurants.data,
  restaurantLoaded: restaurants.loaded,
})

const mapDispatch = {
  getAllUsers: UserActions.getAllUsers,
  removeUsersListener: UserActions.removeUsersListener,
  getRestaurants: RestaurantActions.fetchRestaurantsRequest,
}

export default connect(
  mapState,
  mapDispatch
)(UsersManagementContainer)



// WEBPACK FOOTER //
// ./src/containers/users/index.js